// extracted by mini-css-extract-plugin
module.exports = {"link":"_2ZCRfo816sXov3BSVduNhw"};